import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../axiosInstance";

// Edits show_toast / toast_message for one row; url is the PUT .../{id}/toast endpoint.
// extraPayload is sent along with the toast fields, for endpoints that update the whole row.
function ToastDialog({ row, url, title, onClose, onSuccess, extraPayload }) {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setShowToast(Boolean(row?.showToast));
    setToastMessage(row?.toastMessage || "");
  }, [row]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await api.put(url, { ...extraPayload, showToast, toastMessage });
      toast.success("Toast updated successfully!");
      onSuccess(res.data.data);
      onClose();
    } catch (error) {
      console.error("Toast update failed:", error);
      toast.error("Failed to update toast. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={!!row}
      onClose={() => !saving && onClose()}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={
            <Switch
              checked={showToast}
              onChange={(e) => setShowToast(e.target.checked)}
            />
          }
          label="Show Toast"
        />
        <TextField
          label="Toast Message"
          value={toastMessage}
          onChange={(e) => setToastMessage(e.target.value)}
          inputProps={{ maxLength: 255 }}
          multiline
          minRows={2}
          fullWidth
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ToastDialog;
